import { useLanguage } from "../../contexts/LanguageContext";
import wysoko from '../pictures/wysoko.jpg';
import reko from '../pictures/reko.jpg';
function Straz() {
  const { t } = useLanguage();
  return (
    <section id="straz" className="animate-fade-in py-10 min-h-full">
      <h1 className="text-5xl font-bold text-center mb-16 bg-clip-text text-transparent bg-gradient-to-r from-purple-500 to-cyan-500 leading-tight p-1">
        {t('guardTitle')}
      </h1>
      
      {/* Straż */}  
      <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center mb-20">
        <div className="order-2 md:order-1">
          <h2 className="text-3xl font-bold text-white mb-4">{t('guardSubtitle1')}</h2>
          <p className="text-gray-400 leading-loose">
            {t('guardText1')}
          </p>
        </div>
        <div className="order-1 md:order-2 group">
          <img 
            src={wysoko}
            alt="Fire brigade" 
            className="rounded-lg shadow-lg w-full h-auto object-cover transition-all duration-300 transform group-hover:scale-105 group-hover:shadow-cyan-500/20"
          />
        </div>
      </div>

      {/* Rekonstrukcje */}
      <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        <div className="group">
          <img 
            src={reko} 
            alt="Historical reconstructions" 
            className="rounded-lg shadow-lg w-full h-auto object-cover transition-all duration-300 transform group-hover:scale-105 group-hover:shadow-purple-500/20"
          />
        </div>
        <div>
          <h2 className="text-3xl font-bold text-white mb-4">{t('guardSubtitle2')}</h2>
          <p className="text-gray-400 leading-loose">
            {t('guardText2')}
          </p>
        </div>
      </div>
    </section>
  );
};

export default Straz;